import { render, staticRenderFns } from "./Institutions.vue?vue&type=template&id=dc58c480&scoped=true"
import script from "./Institutions.vue?vue&type=script&lang=js"
export * from "./Institutions.vue?vue&type=script&lang=js"
import style0 from "./Institutions.vue?vue&type=style&index=0&id=dc58c480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc58c480",
  null
  
)

export default component.exports